export const SELECT_TENANT = 'tenant/SELECT_TENANT';

export const selectTenant = (tenant) => ({
  type: SELECT_TENANT,
  value: tenant,
});
